import * as React from 'react';

import {Stack} from 'shells/layout/stack/stack';
import {AiLoadingText} from 'shells/loading-placeholder/ai-loading-text';

import styles from './transcript-summary.module.css';

export function TranscriptSummaryGenerating() {
    return (
        <Stack isFullWidth={true} spacing={8}>
            <AiLoadingText />
            <AiLoadingText />
            <div className={styles['last-loading-line-container']}>
                <AiLoadingText />
            </div>
        </Stack>
    );
}
